import AuthorizeAzure from './authorizeAzure'
export default AuthorizeAzure
